var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VPopover,{attrs:{"placement":_setup.props.tooltipPlacement,"trigger":"hover","offset":_setup.props.tooltipOffset,"delay":{ hide: 300 }},scopedSlots:_vm._u([{key:"popover",fn:function(){return [_vm._t("popover")]},proxy:true}],null,true)},[_vm._t("trigger")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }